import { RootStore } from '@ui-framework/index';
import MasterDataStore from './domain/MasterData';
import UserAccessStore from './domain/UserAccess';
import LocaleStore from './domain/Locale';
import ListStore from './domain/List';
import DynamicListStore from './domain/DynamicList';

export const getStoresFromModule = modules => {
  const tmpStores = [];
  modules.every(item => {
    if (item?.stores) {
      tmpStores.push(item?.stores);
    }
    return true;
  });
  return tmpStores;
};

const addToStore = rootStore => {
  return ({ storeName, storeType }) => {
    switch (storeType) {
      case 'LIST_V1':
        rootStore.addUiStore(
          storeName,
          new DynamicListStore(rootStore, storeName),
        );
        break;
      default:
    }
  };
};

function RootStore1({ storesCollection }) {
  const rootStore = new RootStore();

  rootStore.addToStore = addToStore(rootStore);

  rootStore.addDomainStore('masterData', new MasterDataStore(rootStore));
  rootStore.addDomainStore('userAccess', new UserAccessStore(rootStore));
  rootStore.addDomainStore('locale', new LocaleStore(rootStore));
  rootStore.addDomainStore('list', new ListStore(rootStore));

  storesCollection.forEach(stores => {
    stores(rootStore).forEach(store => {
      Object.entries(store).forEach(([key, value]) => {
        rootStore.addUiStore(key, value);
      });
    });
  });

  return rootStore;
}

export default RootStore1;
